import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';
import { Badge, StatusBadge, PriorityBadge } from '../../CaseClient';

// Granular Case-surface widget — renders the case identity block (case
// number + title + status / priority / type / stage badges). Read-only;
// no actions. Admins compose this with case.toolbar / case.summary_fields
// / case.tasks etc. for full custom layouts.

function CaseHeader({ config }) {
  const { case: caseRow } = useLayoutCtx();
  if (!caseRow) {
    return (
      <div style={{ padding: '14px 18px', color: 'var(--text-secondary)', fontSize: '13px' }}>
        No case loaded.
      </div>
    );
  }
  const showNumber = config.show_case_number !== false;
  const showBadges = config.show_badges !== false;
  return (
    <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border-color)', background: 'var(--bg-secondary)' }}>
      {showNumber && (
        <div style={{ fontFamily: 'monospace', fontSize: '11px', color: 'var(--text-secondary)' }}>
          {caseRow.case_number || caseRow.id}
        </div>
      )}
      <h2 style={{ margin: '4px 0 8px', fontSize: '18px', lineHeight: 1.3 }}>
        {caseRow.title || '(untitled case)'}
      </h2>
      {showBadges && (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
          <StatusBadge status={caseRow.status} />
          <PriorityBadge priority={caseRow.priority} />
          {caseRow.case_type?.name && (
            <Badge color="#8b5cf6">
              {caseRow.case_type.icon || '📋'} {caseRow.case_type.name}
            </Badge>
          )}
          {caseRow.current_stage_name && (
            <Badge color="#3b82f6">stage: {caseRow.current_stage_name}</Badge>
          )}
        </div>
      )}
    </div>
  );
}

registerWidget({
  type: 'case.header',
  categories: ['case'],
  palette_label: 'Case header',
  description: 'Case number + title + status / priority / type / stage badges. Read-only identity block.',
  Component: CaseHeader,
  configSchema: {
    fields: [
      { type: 'boolean', name: 'show_case_number', label: 'Show case number', default: true },
      { type: 'boolean', name: 'show_badges', label: 'Show status / priority / type badges', default: true },
    ],
  },
  publishes: [],
  subscribes: ['xv.RefreshContext'],
  group: 'Case',
});
